module.exports = __webpack_public_path__ + "static/media/maps_menu_logo.96e1bc5c.jpg";